import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";
import tokenService from '../../Common/tokenDecoder';

export default {
    getAll,
    getEstatesByGroupID,
    getDivisionByEstateID,
    GetAllCashWorkType,
    SaveCashPluckingRateMappingData,
    GetExestingCashPluckingRateMappingData,
    GetCashPluckingRateMappingData,
    GetCashPluckingRateMappingDataById,
    UpdateCashPluckingRateMappingData,
    GetAllJobType,
    GetAllCashWorkTypeByJobType
};

async function getAll() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllCashWorkType() {
    const response = await CommonGet('/api/CashPluckingRateMapping/GetAllCashWorkType', null);
    let cashWorkTypeArray = []
    for (let item of Object.entries(response.data)) {
        cashWorkTypeArray[item[1]["cashWorkTypeID"]] = item[1]["cashWorkTypeName"]
    }
    return cashWorkTypeArray;
}


async function getEstatesByGroupID(id) {
    var estateArray = [];
    let model = {
        groupID: id == undefined ? 0 : id.toString(),
        enityTypeID: "2"
    };
    const response = await CommonPost('/api/CashPluckingRateMapping/GetOperationEntityIDByEntityTypeIDandGroupID', null, model);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function SaveCashPluckingRateMappingData(saveData) {
    const response = await CommonPost('/api/CashPluckingRateMapping/SaveCashPluckingRateMappingData', null, saveData);
    return response;
}

async function GetExestingCashPluckingRateMappingData(saveData) {
    const response = await CommonPost('/api/CashPluckingRateMapping/GetExestingCashPluckingRateMappingData', null, saveData);
    return response;
}

async function GetCashPluckingRateMappingData(model) {
    const response = await CommonPost('/api/CashPluckingRateMapping/GetCashPluckingRateMappingData', null, model);
    return response;
}

async function GetCashPluckingRateMappingDataById(cashWorkTypeMappingID) {
    const response = await CommonGet('/api/CashPluckingRateMapping/GetCashPluckingRateMappingDataById', 'cashWorkTypeMappingID=' + cashWorkTypeMappingID);
    return response;
}

async function UpdateCashPluckingRateMappingData(saveData) {
    const response = await CommonPost('/api/CashPluckingRateMapping/UpdateCashPluckingRateMappingData', null, saveData);
    return response;
}

async function GetAllJobType() {
    var jobArray = [];
    const response = await CommonGet('/api/CashPluckingRateMapping/GetAllJobType');
    for (let item of Object.entries(response.data)) {
        jobArray[item[1]["jobTypeID"]] = item[1]["jobTypeName"]
    }
    return jobArray;
}

async function GetAllCashWorkTypeByJobType(id) {
    const response = await CommonGet('/api/CashPluckingRateMapping/GetAllCashWorkTypeByJobType', 'jobTypeID=' + id);
    let cashWorkTypeArray = []
    for (let item of Object.entries(response.data)) {
        cashWorkTypeArray[item[1]["cashWorkTypeID"]] = item[1]["cashWorkTypeName"]
    }
    return cashWorkTypeArray;
}
